module.exports = __webpack_public_path__ + "select-arrows-active-af9b0ca4c99482cc8e73e928c49514a6.svg";